export enum PortalNavigation {
  Link,
  Breadcrumb,
  Other
}
